import React from 'react';
import SnapshotCardBase from './SnapshotCardBase';

export default function CookingSnapshotCard({ data, onOpenDrawer }) {
  return (
    <SnapshotCardBase
      title="Yemek ve Davranış"
      help={{
        description: 'Kullanıcıların öneri akışındaki üretim ve karar davranışını özetler.',
        interpretation: 'Pişirme artarken kabul oranı düşüyorsa akışta dolaylı kullanım olabilir.',
        metricExample: 'Seçim yüksek ama pişirme düşükse plan→pişirme kırılımına inmek gerekir.'
      }}
      primary={Number(data?.cooked || 0).toLocaleString('tr-TR')}
      metrics={[
        { label: 'Plan', value: Number(data?.planned || 0).toLocaleString('tr-TR') },
        { label: 'Seçim', value: Number(data?.selected || 0).toLocaleString('tr-TR') },
        { label: 'Kabul', value: `${Number(data?.acceptRate || 0).toLocaleString('tr-TR')}%` },
        { label: 'Wow', value: `${Number(data?.wowRate || 0).toLocaleString('tr-TR')}%` }
      ]}
      onOpenDrawer={onOpenDrawer}
    />
  );
}
